module.exports = __webpack_public_path__ + "img/17.b5af28ad.svg";